module.exports = __webpack_public_path__ + "circle-x.ce1fbd28ddf8bffc755317f781a3a935.svg";